import { render, staticRenderFns } from "./PremiumRecordDetails.vue?vue&type=template&id=a590f0d0&scoped=true&"
import script from "./PremiumRecordDetails.vue?vue&type=script&lang=js&"
export * from "./PremiumRecordDetails.vue?vue&type=script&lang=js&"
import style0 from "./PremiumRecordDetails.vue?vue&type=style&index=0&id=a590f0d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a590f0d0",
  null
  
)

export default component.exports